import { render, staticRenderFns } from "./video.vue?vue&type=template&id=652aa672&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652aa672",
  null
  
)

export default component.exports